/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { FancyActionTrackerFactory } from 'src/app/common/fancy-firebase/services/fancy-action-tracker-factory.service';
import { ProjectCatalogResolver } from 'src/app/services/routing/project-catalog-resolver.service';
import { FancyFirebaseFileAttachApiBuilder } from 'src/app/services/fancy-firebase-api-builder/fancy-firebase-file-attach-api-builder-service';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';
import { FancyFirebaseCustomFieldsApiBuilder } from 'src/app/services/fancy-firebase-api-builder/fancy-firebase-customfields-api-builder.service';
import { FancyFirebaseProjectsApiBuilder } from 'src/app/services/fancy-firebase-api-builder/fancy-firebase-projects-api-builder.service';
import { DockedTicketModule } from 'src/app/common/docked-ticket/docked-ticket.module';

@NgModule({
	declarations: [TicketDetailsComponent],
	imports: [CommonModule, CommonComponentsModule, DockedTicketModule],
	providers: [
		AngularFireDatabase,
		FancyActionTrackerFactory,
		ProjectCatalogResolver,
		FancyFirebaseFileAttachApiBuilder,
		PlanAccessCheck,
		FancyFirebaseCustomFieldsApiBuilder,
		FancyFirebaseProjectsApiBuilder,
		PlanAccessCheck,
	],
	exports: [TicketDetailsComponent],
})
export class TicketDetailsModule {}
